
import React, { useState } from 'react'
import axios from 'axios'
import Navbar from '../components/Navbar';
import '../styles/statistics.css'

function Game_Statistics() {
  const [selectedOption, setSelectedOption] = useState('')
  const [playersResultArray, setPlayersResultArray] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const token = localStorage.getItem('token');

  const handleSelectChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);
    setIsLoading(true)
    axios.get(`https://kaskas.pro/poker-stats-server/api/api/${value}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(response => {
      const data = response.data
      if (!data) return;
      setPlayersResultArray(data.result)
      setIsLoading(false)
    }).catch(err => {
      setIsLoading(false)
    })
  }

  return (
    <>
      <Navbar selectedItem={'gameStatistics'} />

      <div className='selectWrapper'>
        <select className='statisticsSelect' onChange={handleSelectChange} value={selectedOption}>
          <option value="" disabled>בחירת קטגוריה</option>
          <option value="mostProfit">הכי הרבה רווח במשחק אחד</option>
          <option value="biggestLoser">הכבש הכי גדול במשחק אחד</option>
          <option value="biggestBuyer">פרט הכי הרבה במשחק אחד</option>
          <option value="averageProfit">ממוצע רווח למשחק</option>
          <option value="mostProfitTotal">סך הכל רווחים</option>
          <option value="biggestLoserTotal">הכבש הכי גדול סך הכל</option>
          <option value="biggestRakeDonator">מלך הגניות</option>
        </select>
      </div>
      {isLoading ? <div className='loaderWrapper'><div className='loader'></div></div> : <div className='tableWrapper'>
        <table className="statisticsTable">
          <thead>
            <tr>
              <th>כמות</th>
              <th>שם השחקן</th>
              <th>מקום</th>
            </tr>
          </thead>
          <tbody>
            {playersResultArray.map((player, index) => (
              <tr key={index}>
                <td>{player.amount}</td>
                <td>{player.player_name}</td>
                <td>{index + 1}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      }
    </>
  )
}

export default Game_Statistics